(function () {
  'use strict';

  angular.module('PrinterList')

    .constant('PRINTER_FILTERS', [
      {
        name: 'Network',
        parameter: 'networks',
        type: 'pagination',
        service: 'NetworkListService',
        paginationObject: null,
        values: []
      },
      {
        name: 'NetworkType',
        parameter: 'networkTypeFilter',
        type: 'checkbox',
        values: [{
          key: 'OFFICE',
          value: 'Company',
          type: 'checkbox'
        },
        {
          key: 'HOME',
          value: 'HomeOffice',
          type: 'checkbox'
        }
        ]
      },
      {
        name: 'Created',
        parameter: null,
        type: 'range-date',
        sharedKey: 'dateRange',
        dateRange: {
          key: 'dateRange',
          value: 'Created',
          type: 'range-date',
          keys: [{
            key: 'createdFrom',
            count: null
          }, {
            key: 'createdTo',
            count: null
          }]
        },
        values: [{
          key: 'dateFrom',
          value: 'From',
          sharedKey: 'dateRange',
          initialCount: null,
          parameter: 'createdFrom',
          type: 'range-date'
        },
        {
          key: 'dateTo',
          value: 'To',
          sharedKey: 'dateRange',
          initialCount: null,
          parameter: 'createdTo',
          type: 'range-date'
        }
        ]
      },
      {
        name: 'Vendors',
        parameter: 'vendor',
        type: 'flat_list',
        setBreaker: true,
        values: []
      },
      {
        name: 'GoPrinters',
        parameter: 'withOndevice',
        type: 'radio',
        values: [{
          key: 'withOndevice',
          value: 'Yes',
          state: true
        },
        {
          key: 'withOndevice',
          value: 'No',
          state: false
        },
        {
          key: 'withOndevice',
          value: 'ClearFilter',
          state: null
        }
        ]
      },
      {
        name: 'GoConfigurations',
        parameter: 'ondeviceconfigs',
        type: 'pagination',
        service: 'OnDeviceConfigService',
        values: []
      },
      {
        name: 'SignInProfiles',
        parameter: 'credentials',
        type: 'pagination',
        service: 'GoProfileService',
        values: []
      }
    ])

    .constant('SORT_PRINTERS', {
      NAME: 'PrinterName',
      SIGN_ID: 'Id',
      STATUS: 'Status',
      CREATED: 'Created',
      LOCATION: 'Location'
    })

    .constant('PRINTER_VIEW_MODES', {
      mode: 'DEFAULT',
      customAttrs: []
    })

    .constant('DEFAULT_VIEW_MODES', {
      DEFAULT: ['Queues', 'Status', 'Network', 'IpAddress', 'Created', 'Location'],
      CONNECTION: ['Status', 'Network', 'IpAddress', 'MacAddress', 'Snmp', 'Protocol', 'Site'],
      GO: ['Status', 'Installed', 'Vendor', 'GoVersion', 'CaptureVersion', 'GoConfiguration', 'SignInProfile', 'CardReaders']
    }
    )

    .controller('PrinterListController', function (
      $rootScope, $scope, $filter, $location, URLS, PrinterListService, PRINTER_TYPES,
      $ngBootbox, URL_PARAMS, toastr,
      SORT_PRINTERS, PRINTER_FILTERS, GroupListService, $timeout, NetworkListPaging,
      PrinterModel, EventHandlerService, currentTenant,
      $window, PrinterListPOSTPaging, $routeParams, WorkstationListPOSTPaging,
      enums, localStorageService, $cookies, PRINTER_VIEW_MODES, DEFAULT_VIEW_MODES, CopilotService) {

      $scope.tenant = currentTenant;
      $scope.groupEnabled = false;
      $scope.checkAllCheckboxes = false;
      $scope.selectedPrinters = 0;
      $scope.urls = URLS;
      $scope.printerListService = PrinterListService;
      $scope.printerTypes = PRINTER_TYPES;
      $scope.printerQueueStates = [];
      $scope.showQueues = false;
      $scope.printerState = {};
      $scope.currentDate = new Date();
      $scope.thresholdToSwitchCreatedTimeFormat = 6;
      $scope.helpCaption = 'HelpPrintersPage';
      $scope.eventHandlerService = EventHandlerService;
      $scope.workstationListPaging = new WorkstationListPOSTPaging();

      $scope.orderByText = 'Id';
      $scope.searchInputPlaceholderText = 'Search';
      $scope.printerListPaging = new PrinterListPOSTPaging();
      $scope.networkListPaging = new NetworkListPaging();
      $scope.printerUnderCreationListPaging = new PrinterListPOSTPaging();
      $scope.printerContainer = null;
      $scope.noDataMessage = 'NoSearchResultPrinter';
      $scope.groupListService = GroupListService;
      $scope.printersUnderCreationTotalNumber = 0;
      $scope.me = null;
      let initialListRequest = true;
      $scope.windowWidth = $window.innerWidth;
      $scope.loadingPage = true;
      $scope.DEFAULT_VIEW_MODES = DEFAULT_VIEW_MODES;

      $scope.showPrinterTableOptions = false;
      $scope.showGoOptions = false;
      $scope.printerEditMode = false;

      $scope.storageObject = null;
      if (localStorageService.isSupported) {
        $scope.storageObject = localStorageService;
      } else {
        $scope.storageObject = $cookies;
        $scope.storageObject.set = function (key, value) {
          return $scope.storageObject.put(key, value);
        };
      }

      // FILTER CONFIGURATION
      (function () {
        initEventHandler();
        checkGroupEnabled();
        scrollListener();
        getViewModeStorage();
        removeGoStuff();
      }());

      function fulfillCopilotRequest() {
        if (CopilotService.state.requestedAction.responseType == 'SEARCH_PRINTERS') {
          const pattern = CopilotService.usePrinterSearchString();
          if (pattern) {
            $scope.searchPattern = pattern;
          }
          return;
        }

        const copilotActionElements = angular.element('[copilot-action]');
        if (!copilotActionElements) {
          return;
        }

        // Filter the buttons for the one with the value 'DISCOVER_PRINTERS'
        const copilotActionButton = Array
          .from(copilotActionElements)
          .find(button => button.getAttribute('copilot-action') === 'DISCOVER_PRINTERS');
        if (!copilotActionButton) { return; }
        const copilotAction = copilotActionButton.getAttribute('copilot-action');
        if (!copilotAction || CopilotService.state.requestedAction.responseType !== copilotAction) {
          return;
        }

        // Note: Using hardcoded coordinates because there are cases where
        // the button rect comes back as 0,0,0,0 or off the screen.
        // const elementRect = copilotActionButton.getBoundingClientRect();
        const clientX = CopilotService.getAvailableWidth();
        const clientY = 100;
        $scope.popupOpen({ clientX, clientY, stopPropagation: () => {} });
      }

      function removeGoStuff() {
        if ($scope.tenant.info.enableOnDevice === 'DISABLED') {
          delete $scope.DEFAULT_VIEW_MODES.GO;
          PRINTER_FILTERS.splice(4, 3);
          PRINTER_FILTERS[3].setBreaker = false;
        }
      }

      function getViewModeStorage() {
        let viewMode = null;
        if (!$scope.storageObject.get('printersViewMode')) {
          viewMode = PRINTER_VIEW_MODES;
          setDefaultViewModeStorage(viewMode);
          setViewMode(viewMode);
        } else {

          viewMode = $scope.storageObject.get('printersViewMode');
          setViewMode(viewMode);
        }
      };

      function setDefaultViewModeStorage(viewMode) {
        $scope.storageObject.set('printersViewMode', viewMode);
      };

      $scope.changeViewMode = function (viewMode) {
        setViewMode(viewMode);
        $scope.getPrinterListPaged();
      };

      $scope.exitPrinterTableMenu = function () {
        $scope.showPrinterTableOptions = false;
      };

      function setViewMode(viewMode) {

        closeAllMenues();
        if (viewMode.customAttrs.length > 3) {
          document.documentElement.style.setProperty('--cellSize', '200px');
        } else {
          document.documentElement.style.setProperty('--cellSize', `${100 / viewMode.customAttrs.length}%`);
        }

        document.documentElement.style.setProperty('--colNum', viewMode.customAttrs.length);
        $scope.showPrinterTableOptions = false;
        if (viewMode) {
          angular.element('.grid-container').css({ opacity: 0 });

          $timeout(() => {
            $scope.viewMode = viewMode;
          }, 100);
          $timeout(() => {
            angular.element('.grid-container').css({ opacity: 1 });
          }, 800);

        $scope.viewMode = viewMode;
        }

      }

      $scope.viewModeCaption = function () {
        return $filter('translate')('PrintersViewMode') + ': ' + $filter('translate')(viewModeCaption());
      };

      function viewModeCaption() {
        let caption = '';
        switch ($scope.viewMode.mode) {
          case 'DEFAULT':
            caption = 'Default';
            break;
          case 'CONNECTION':
            caption = 'Connection';
            break;
          case 'GO':
            caption = 'Printix Go';
            break;
          case 'CUSTOM':
            caption = 'Customized';
            break;
        }
        return caption;
      }

      $scope.updatePrinterGo = function (printer) {
        $scope.tenant.updateGoPrintersSoftware([printer]).then(function (response) {
          console.log(response);
        }).catch(function (error) {
          console.log(error);
        });
      };

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          const printerFilters = angular.copy(PRINTER_FILTERS);
          initFilters(adjustToUserPermissions(printerFilters));

          $scope.getPrinterUnderCreationListPaged();
          fulfillCopilotRequest();
        }
      });

      function adjustToUserPermissions(printerFilters) {
        printerFilters[0].paginationObject = new NetworkListPaging();

        if (!$scope.me.permissions.TENANT_ADMIN) {
          $scope.printerListPaging.pagingCriteria.networkFilterEnabled = true;
          $scope.printerListPaging.pagingCriteria.includeUnassignedPrinters = false;
          $scope.printerListPaging.pagingCriteria.networks = $scope.me.networks;

          // if the user is a site manager, then show the vendor filter list as well
          if ($scope.me.info._embedded.permissions.role === 'USER' && $scope.me.info._embedded.permissions.roles.includes('SITE_MANAGER')) {
            printerFilters[3].values = enums.Vendor;
          }
        } else {
          printerFilters[3].values = enums.Vendor;
        }

        $scope.printerListPaging.pagingCriteria.page = $routeParams.printerPage > 0 ? $routeParams.printerPage - 1 : 0;
        return printerFilters;
      }

      function initFilters(printerFilters) {
        $scope.requestType = 'POST';
        $scope.filtersList = printerFilters;
      }

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      }

      function checkGroupEnabled() {
        if (currentTenant.info.groupsEnabled) {
          $scope.groupEnabled = true;
        } else {
          $scope.groupEnabled = false;
        }
      }

      function reportWindowSize() {
        $scope.windowWidth = $window.innerWidth;
        resetScroll();
        $scope.$apply();
      }
      window.onresize = reportWindowSize;

      $scope.startDiscovery = function (selectedNetwork, snmpConfig) {
        if (selectedNetwork) {
          selectedNetwork.discoverNetwork(selectedNetwork, snmpConfig).then(function () {
            toastr.success($filter('translate')('DiscoveryStarted'));
          }).catch(function (error) {
            console.log(error);
          });
        }
      };

      $scope.deletePrinter = function (printer) {
        if (printer) {
          const printerName = (printer.info.type === PRINTER_TYPES.FREEDOM) ? printer.info.name : printer.info.signId;
          $ngBootbox.confirm($filter('stringular')($filter('translate')('DeletePrinter'), printerName)).then(function () {
            PrinterListService.deletePrinter(printer).then(function () {
              toastr.success($filter('stringular')($filter('translate')('PrinterDeleted'), printerName));
            }).catch(function (error) {
              console.log(error);
            });
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          throw '$scope.deletePrinter: printer is missing';
        }
      };

      $scope.deleteSelectedPrinters = function () {
        if ($scope.printerContainer.list.length > 0) {
          const searchCriteriaObject = {
            options: {
              isSelected: true
            }
          };
          const printerList = $scope.printerContainer.list.findAllElements(searchCriteriaObject);
          if (printerList.length > 0) {
            const printerName = (printerList[0].info.type === PRINTER_TYPES.FREEDOM) ? printerList[0].info.name : printerList[0].info.signId;
            let message = '';
            if (printerList.length < 2) {
              message = $filter('stringular')($filter('translate')('DeletePrinter'), printerName);
            } else {
              message = $filter('stringular')($filter('translate')('DeletePrinters'), printerList.length);
            }
            $ngBootbox.confirm(message).then(function () {
              PrinterListService.deleteSelectedPrinters(printerList, function () {
                let message = '';
                if (printerList.length < 2) {
                  message = $filter('stringular')($filter('translate')('PrinterDeleted'), printerName);
                } else {
                  message = $filter('stringular')($filter('translate')('PrintersDeleted'), printerList.length);
                }
                toastr.success(message);
              });
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            toastr.error($filter('translate')('SelectPrinterNone') + ', ' + $filter('translate')('SelectPrinter'));
          }
        } else {
          toastr.error($filter('translate')('SelectPrinterNone'));
        }
      };

      $scope.getNetworkName = function (printer) {
        if (printer.info._links['px:network']) {
          const network = $scope.printerContainer.networks.findElement({
            _links: { self: { href: printer.info._links['px:network'].href } }
          });
          if (network) {
            return network.name;
          } else {
            return $filter('translate')('UnknownNetwork');
          }
        } else {
          return '';
        }
      };

      $scope.editSelectedPrinters = function () {
        if ($scope.printerContainer.list.length > 0) {
          const selectedItems = $scope.printerContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          });
          if (selectedItems.length > 0) {
            const printerURLArray = [];
            angular.forEach(selectedItems, function (printer) {
              printerURLArray.push(printer.info._links.self.href.split('printers/')[1]);
            });
            $location.path(URLS.PRINTER_PROPERTIES_MULTI.replace(URL_PARAMS.PRINTER_URL.LOCATION, printerURLArray));
          } else {
            throw '$scope.editSelectedPrinters: selectedItems or printer are missing';
          }
        }
      };

      $scope.selectAllItems = function () {
        angular.forEach($scope.printerContainer.list, function (value) {
          value.options.isSelected = $scope.checkAllCheckboxes;
        });
      };

      $scope.popupOpen = function (event) {
        event.stopPropagation();

        $scope.networkListPaging.pagingCriteria.pageSize = 5;
        $scope.networkListPaging.pagingCriteria.match = null;

        $timeout(function () {
          $scope.clearPopup();
          $scope.popupObject = {
            pointerDirection: 'right',
            pointerPosition: 'up',
            dimensions: { width: 400 },
            relativePosition: 'left',
            offset: { top: 40, left: 120 },
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            context: 'discoverPrinters',
            type: 'SELECT_NETWORK_AND_SNMP',
            title: 'DiscoverPrinters',
            confirmText: 'DiscoverPrinters',
            clickOutsideToClose: false,
            noPointer: true
          };
        }, 100);
      };

      $scope.clearPopup = function () {
        $scope.printerStatusObject = null;
        $scope.printerStatusPopupObject = null;

        $scope.popupObject = null;
      };

      $scope.changeOrderByValue = function (textValue) {
        if ($scope.reverse) {
          $scope.printerListPaging.pagingCriteria.direction = 'ASC';
          $scope.printerListPaging.pagingCriteria.sort = textValue;
        } else {
          $scope.printerListPaging.pagingCriteria.direction = 'DESC';
          $scope.printerListPaging.pagingCriteria.sort = textValue;
        }
        $scope.reverse = !$scope.reverse;
        $scope.orderByText = SORT_PRINTERS[textValue];
        $scope.getPrinterListPaged();
      };

      $scope.getPrinterListPaged = function (skipResetScroll) {
        if (!skipResetScroll) {
          angular.element('.px-scrollbar-scroll').scrollTop(0);
          resetScroll();
        }

        $scope.loadingPage = true;

        if (!$scope.me.permissions.TENANT_ADMIN) {
          if (!$scope.printerListPaging.pagingCriteria.networks?.length) {
            $scope.printerListPaging.pagingCriteria.networks = $scope.me.networks;
          }
        }

        // Embed site resources only if required by the view mode.
        if ($scope.viewMode.mode === 'CONNECTION' || ($scope.viewMode.mode === 'CUSTOM' && $scope.viewMode.customAttrs.includes('Site'))) {
          if (!$scope.printerListPaging.pagingCriteria.embed.includes('sites')) {
            $scope.printerListPaging.pagingCriteria.embed.push('sites');
          }
        } else {
          const index = $scope.printerListPaging.pagingCriteria.embed.indexOf('sites');
          if (index !== -1) {
            $scope.printerListPaging.pagingCriteria.embed.splice(index, 1);
          }
        }

        $scope.printerListPaging.pagingCriteria.types = ['NETWORK', 'VIRTUAL'];
        $scope.eventHandlerService.queue.stopQueue();
        PrinterListService.postGetPrinterListPaged($scope.printerListPaging).then(function (printerContainer) {

          if (initialListRequest || $scope.printerListPaging.pagingCriteria.page === 0) {
            initialListRequest = false;
            $location.path($location.path(), false).search({ printerPage: parseInt($scope.printerListPaging.pagingCriteria.page) + 1 }).replace();
          } else {
            $location.path($location.path(), false).search({ printerPage: parseInt($scope.printerListPaging.pagingCriteria.page) + 1 });
          }

          if (printerContainer.list) {
            printerContainer = isolateNetworkId(printerContainer);
            printerContainer = setPrinterResources(printerContainer);
          }

          $scope.printerContainer = angular.copy(printerContainer);

          $scope.loadingPage = false;
          if ($scope.eventHandlerService.getControllerScope() !== 'printerList') {
            $scope.eventHandlerService.setControllerScopeData('printerList', $scope.printerContainer.list);
          } else {
            refreshEventHandler();
          }
        }).catch(function () {
          refreshEventHandler();
        });
      };

      function debounceFunc(func, timeout) {
        let timerId = null;
        return () => {
          if (timerId) {
            clearTimeout(timerId);
          }
          timerId = setTimeout(() => {
            func();
          }, timeout);
        };
      }

      $scope.getPrinterListPagedDebounced = debounceFunc($scope.getPrinterListPaged, 500);

      function setPrinterResources(printerContainer) {
        angular.forEach(printerContainer.list, (printer) => {
          printer.info.network = findResource(printer, printerContainer.networks, 'px:network');
          printer.info.onDeviceConfig = findResource(printer, printerContainer.onDeviceConfigResources, 'px:onDeviceConfigLink');
          printer.info.printerCredential = findResource(printer, printerContainer.printerCredentialResources, 'px:printerCredentialLink');
          printer.info.snmpConfig = findResource(printer, printerContainer.snmpConfigurationResources, 'px:snmpConfiguration');
          if (printer.info.network?._links['px:site']) {
            printer.info._links['px:site'] = printer.info.network._links['px:site'];
          }
          printer.info.site = findResource(printer, printerContainer.sites, 'px:site');
        });
        return printerContainer;
      }

      function findResource(printer, resourceList, linkRef) {
        const printerResourceID = printer.info._links[linkRef]?.href;
        if (printerResourceID) {
          return resourceList.find(resource => resource._links.self.href === printerResourceID);
        } else {
          return null;
        }
      }

      function isolateNetworkId(printerContainer) {
        printerContainer.list.forEach(printer => {
          const networkLink = printer.info._links['px:network'];
          if (networkLink) {
            const networkID = networkLink.href.split('/').pop();
            printer.info.networkID = networkID;
          }
        });
        return printerContainer;
      }

      $scope.getNextPage = function functionName(showPrevious) {
        if (showPrevious) {
          if ($scope.printerListPaging.pagingCriteria.page > 0) {
            $scope.printerListPaging.pagingCriteria.page--;
          }
        } else {
          if ($scope.printerListPaging.pagingCriteria.page + 1 < $scope.printerContainer.page.totalPages) {
            $scope.printerListPaging.pagingCriteria.page++;
          }
        }

        $scope.getPrinterListPaged();
      };

      const PRINTER_LIST_listener = $rootScope.$on('printerList', function (name, data) {
        console.log('%c**' + data.operation + '**', 'color: yellowgreen; font-size: 20px');
        switch (data.operation) {
          case 'refreshList':
            $scope.getPrinterListPaged(true);
            $scope.getPrinterUnderCreationListPaged();
            break;
          case 'replaceItem':
            getPrinterByUrl(data.itemId);
            break;
          case 'silentUpdate':
            if (Array.isArray(data.list)) {
              updateDomSilently(data.list);
            } else {
              const updatedPrinter = new PrinterModel(data.list.info);
              updatedPrinter.info.network = findResource(updatedPrinter, $scope.printerContainer.networks, 'px:network');
              updatedPrinter.info.onDeviceConfig = findResource(updatedPrinter, $scope.printerContainer.onDeviceConfigResources, 'px:onDeviceConfigLink');
              updatedPrinter.info.printerCredential = findResource(updatedPrinter, $scope.printerContainer.printerCredentialResources, 'px:printerCredentialLink');
              updatedPrinter.info.snmpConfig = findResource(updatedPrinter, $scope.printerContainer.snmpConfigurationResources, 'px:snmpConfiguration');
              updatedPrinter.options = data.list.options;
              const printerID = updatedPrinter.info._links.self.href;
              const foundPrinter = $scope.printerContainer.list.find(printer => printer.info._links.self.href === printerID);
              if (foundPrinter) {
                Object.assign(foundPrinter, updatedPrinter);
              }
            }
            break;
        }
      });

      const ADD_CONFIG_listener = $rootScope.$on('ADD_CONFIG', (name, data) => {
        const config = $scope.printerContainer.onDeviceConfigResources.find(config => config._links.self.href === data.config.info._links.self.href);
        if (!config) {
          $scope.printerContainer.onDeviceConfigResources.push(data.config.info);
        }
      });

      const ADD_CREDENTIAL_listener = $rootScope.$on('ADD_CREDENTIAL', (name, data) => {
        const credential = $scope.printerContainer.printerCredentialResources.find(credential => credential._links.self.href === data.credential.info._links.self.href);
        if (!credential) {
          $scope.printerContainer.printerCredentialResources.push(data.credential.info);
        }
      });

      function getPrinterByUrl(printerId) {
        $scope.eventHandlerService.queue.stopQueue();
        PrinterListService.getPrinterByURL(printerId, ',latestOnDeviceVersion').then(function (printer) {

          printer.info.network = findResource(printer, $scope.printerContainer.networks, 'px:network');
          printer.info.onDeviceConfig = findResource(printer, $scope.printerContainer.onDeviceConfigResources, 'px:onDeviceConfigLink');
          printer.info.printerCredential = findResource(printer, $scope.printerContainer.printerCredentialResources, 'px:printerCredentialLink');
          printer.info.snmpConfig = findResource(printer, $scope.printerContainer.snmpConfigurationResources, 'px:snmpConfiguration');

          $scope.printerContainer.list.forEach((item, i) => {
            if (item.info._links.self.href === printer.info._links.self.href) {
              Object.assign(item.info, printer.info);
              item.resources.queues = printer.resources.queues;
            }
          });

          if ($scope.printerEditMode) {
            $rootScope.$broadcast('UPDATE_PRINTER_IN_EDITMODE', { printer });
          }

          refreshEventHandler();
        }).catch(function () {
          refreshEventHandler();
        });
      }

      function refreshEventHandler() {
        $scope.eventHandlerService.refreshScopeData('printerList', $scope.printerContainer.list).then(function () {
          $scope.eventHandlerService.queue.setState('idle');
        }).catch(function (error) {});
      }

      function updateDomSilently(modifiedPrinterList) {
        const updatedPrinterList = [];
        for (let i = 0; i < modifiedPrinterList.length; i++) {
          const printer = new PrinterModel(modifiedPrinterList[i].info);

          printer.options = modifiedPrinterList[i].options;

          printer.info.network = findResource(printer, $scope.printerContainer.networks, 'px:network');
          printer.info.onDeviceConfig = findResource(printer, $scope.printerContainer.onDeviceConfigResources, 'px:onDeviceConfigLink');
          printer.info.printerCredential = findResource(printer, $scope.printerContainer.printerCredentialResources, 'px:printerCredentialLink');
          printer.info.snmpConfig = findResource(printer, $scope.printerContainer.snmpConfigurationResources, 'px:snmpConfiguration');

          updatedPrinterList.push(printer);
        }

        $scope.printerContainer.list = updatedPrinterList;
      }

      $scope.$watch(function () {
        if ($scope.printerContainer) {
          return $scope.printerContainer.list;
        }
      }, function () {
        if ($scope.printerContainer) {
          $scope.selectedPrinters = $scope.printerContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          }).length;
          if (!$scope.selectedPrinters) {
            $scope.checkAllCheckboxes = false;
          } else {
            $scope.checkAllCheckboxes = ($scope.selectedPrinters === $scope.printerContainer.list.length);

          }
        }
      }, true);

      $scope.getPrinterUnderCreationListPaged = function () {
        $scope.printerUnderCreationListPaging.pagingCriteria.pageSize = 1;
        $scope.printerUnderCreationListPaging.pagingCriteria.networkTypeFilter = 'NONE';
        $scope.printerUnderCreationListPaging.pagingCriteria.networks = $scope.me.permissions.TENANT_ADMIN ? null : $scope.me.networks;
        $scope.printerUnderCreationListPaging.pagingCriteria.underCreation = true;
        PrinterListService.getPrinterListPaged($scope.printerUnderCreationListPaging)
          .then(function (printerListObject) {
            $scope.printersUnderCreationTotalNumber = printerListObject.page.totalElements;
          }).catch(function (error) {
            console.log(error);
          });
      };

      /// /////////////////////////////////////////
      /// /////////////////////////////////////////
      // Context stuff
      /// /////////////////////////////////////////

      $scope.openCollectionContext = function (event, menuOption, printer) {
        $scope.closeAllMenues();
        $scope.printerEditMode = true;
        $timeout(() => {
          menuOption.bypassCloseOutside = true;
          $scope.selectedContextMenuItem  =  menuOption;
          $scope.contextContentPosition = { left: event.clientX, top: event.clientY };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };

          if (printer) {
            $scope.context = [angular.copy(printer)];
          } else if ($scope.printerContainer.list.filter(printer => printer.options.isSelected).length > 0) {
            $scope.context = angular.copy($scope.printerContainer.list.filter(printer => printer.options.isSelected));
          } else  {
            $scope.context = angular.copy($scope.printerContainer.list);
          }

          angular.forEach($scope.printerContainer.list, (printer) => {
            printer.options.isSelected = false;
          });

          $scope.auxiliaries = {
            tenant: currentTenant,
            enums
          };
        }, 50);
      };

      $scope.openContext = function (event, context, menuOption) {
        $scope.closeAllMenues();
        $timeout(function  () {
          $scope.selectedContextMenuItem  =  menuOption;
          $scope.contextContentPosition = { left: event.clientX, top: event.clientY };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          $scope.contextContent = context;
          $scope.context = context;
          $scope.auxiliaries = {
            tenant: currentTenant
          };
        }, 50);
      };

      $scope.closeAllMenues = function () {
        closeAllMenues();
      };

      function closeAllMenues() {
        $scope.printerEditMode = false;
        $scope.showGoOptions = false;
        $scope.showPrinterTableOptions = false;
        $scope.menuContent = null;
        $scope.menuSpecs = null;
        $scope.selectedContextMenuItem = null;
        $scope.contextContentPosition = null;
        $scope.contextPosition = null;
        $scope.contextContent = null;
        $scope.context = null;
        $scope.auxiliaries = null;
      }

      $scope.copyIpAddress = function (ipAddress) {
        if (!ipAddress.startsWith('\\\\')) {
          ipAddress = ipAddress.split(' ')[0];
        }
        const input = document.createElement('input');
        input.setAttribute('value', ipAddress);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        toastr.success($filter('translate')('CopyToClipboard'));
      };

      /// /////////////////////////////////////////
      /// /////////////////////////////////////////
      // TOOLTIP STUFF
      /// /////////////////////////////////////////
      $scope.showTooltip = function (showTip, position, tooltipScope, context, arg) {
        if (showTip) {
          switch (tooltipScope) {
            case 'cardReader':
              cardReaderTooltip(position, context);
              break;
            case 'protocol':
              protocolTooltip(position, context);
              break;
            case 'goConfiguration':
              goConfigurationTooltip(position, context);
              break;
            case 'signInProfile':
              signInProfileTooltip(position, context);
              break;
            case 'network':
              networkTooltip(position, context);
              break;
            case 'site':
              siteTooltip(position, context, arg);
              break;
            case 'printer':
              printerTooltip(position, context);
              break;
          }
        } else {
          $scope.clearTooltip();
        }
      };

      function cardReaderTooltip(position, cardReader) {

        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'CardReader',
          type: 'cardReader',
          cardReader
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function networkTooltip(position, printer) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'Printer',
          type: 'network',
          printer: printer.info
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function signInProfileTooltip(position, printer) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'Printer',
          type: 'signInProfile',
          printer: printer.info
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function goConfigurationTooltip(position, printer) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'Printer',
          type: 'goConfiguration',
          printer: printer.info
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function protocolTooltip(position, printer) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'Printer',
          type: 'protocol',
          printer: printer.info
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function siteTooltip(position, title, arg) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          title,
          arg,
          type: 'statement'
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function printerTooltip(position, printer) {
        // printer.info.network = $scope.getNetworkName(printer);
        printer.info.thresholdToSwitchCreatedTimeFormat = $scope.thresholdToSwitchCreatedTimeFormat;
        printer.info.currentDate = $scope.currentDate;

        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'Printer',
          type: 'printerDetails',
          printer: printer.info
        };
        $scope.tooltipObject = {
          position: { left: position.startX - 15, top: position.startY + 20 },
          contextMenu: false
        };
      }

      $scope.clearTooltip = function () {
        $scope.tooltipContent = null;
        $scope.tooltipObject = null;
      };

      /// /////////////////////////////////////////
      /// /////////////////////////////////////////
      // LIST MENU
      /// /////////////////////////////////////////
      $scope.openListMenu = function (event, printer) {
        $scope.closeAllMenues();
        const position = document.getElementById(event.target.id).getBoundingClientRect();
        setTimeout(function () {
          $scope.closeListMenu();
          $scope.listMenuContext = printer;
          $scope.listMeta = {
            position: { left: position.x, top: position.y },
            parentId: event.target.id,
            type: 'printerList',
            scrollContainerId: 'PrinterScrollContainer'
          };
          $scope.$apply();
        }, 50);
      };

      $scope.closeListMenu = function (printer, action) {
        $scope.listMenuContext = null;
        $scope.listMeta = null;

        switch (action) {
          case 'DELETE_PRINTER':
            $scope.deletePrinter(printer);
            break;
        }
      };

      $scope.scrollingLEFT = false;
      $scope.scrollingTOP = false;

      function scrollListener() {
        let scrollLeft = 0;
        const scrollTop = 0;

        angular.element('#PrinterScrollContainer').on('scroll', function (event) {
          if (event.currentTarget.scrollLeft !== scrollLeft) {
            $scope.scrollingLEFT = true;
            scrollLeft = event.currentTarget.scrollLeft;
            $scope.$apply();
          } else {
            $scope.scrollingLEFT = false;
          }

          if ($scope.scrollingLEFT) {
            $timeout(() => {
              $scope.scrollingLEFT = false;
            }, 1500);
          }

        });
      }

      $scope.openTableMenu = function () {
        $scope.closeAllMenues();
        $scope.showPrinterTableOptions = !$scope.showPrinterTableOptions;
      };

      function resetScroll() {
        angular.element('.px-scrollbar-scroll').scrollLeft(0);
        angular.element('.grid-th').css({ top: 0 });
        angular.element('.fixed-cb').css({ left: 0 });
        angular.element('.fixed-id').css({ left: 52 });
        angular.element('.fixed-name').css({ left: 118 });
        angular.element('.fixed-menu').css({ right: 0 });
      }

      $scope.$on('$destroy', function () {
        angular.element('#PrinterScrollContainer').off('scroll', function () {});
        PRINTER_LIST_listener();
        ADD_CONFIG_listener();
        ADD_CREDENTIAL_listener();
        window.onresize = null;
      });

    }
    );
})();
